import type { CSSProperties } from 'react';
import type { Compound, DriverState, RaceSnapshot, TrackStatus } from '../../shared/race';
import { TELEMETRY_MAX_AGE_MS } from './dataPresentation';

export const compoundNames: Record<Compound, string> = {
  SOFT: '软胎', MEDIUM: '中性胎', HARD: '硬胎', INTERMEDIATE: '半雨胎', WET: '全雨胎', UNKNOWN: '未知轮胎',
};
export const compoundCodes: Record<Compound, string> = {
  SOFT: 'S', MEDIUM: 'M', HARD: 'H', INTERMEDIATE: 'I', WET: 'W', UNKNOWN: '—',
};
export const statusNames: Record<TrackStatus, string> = {
  GREEN: '绿旗', YELLOW: '黄旗', RED: '红旗', SC: '安全车', VSC: '虚拟安全车', FINISHED: '已结束', UNKNOWN: '等待状态',
};
const messageTimeFormatter = new Intl.DateTimeFormat('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'Asia/Shanghai' });

export function lapTime(seconds: number | null) {
  if (seconds === null || !Number.isFinite(seconds)) return '—';
  const milliseconds = Math.round(seconds * 1000);
  const minutes = Math.floor(milliseconds / 60000);
  return `${minutes}:${((milliseconds % 60000) / 1000).toFixed(3).padStart(6, '0')}`;
}

export function gap(value: number | string | null, leader = false) {
  if (leader && value === 0) return 'LEADER';
  if (value === null) return '—';
  if (typeof value === 'string') return value;
  return `${value > 0 ? '+' : ''}${value.toFixed(3)}`;
}

export function numeric(value: number | null, digits = 0) {
  return value === null || !Number.isFinite(value) ? '—' : value.toFixed(digits);
}

export function teamColor(value: string) {
  const normalized = value.startsWith('#') ? value : `#${value}`;
  return /^#[\da-f]{6}$/i.test(normalized) ? normalized : '#98a5b7';
}

export function driverStyle(driver: Pick<DriverState, 'teamColor'>): CSSProperties {
  return { '--team-color': teamColor(driver.teamColor) } as CSSProperties;
}

export function eventTime(atMs: number, snapshot: RaceSnapshot) {
  const timestamp = Date.parse(snapshot.session.dateStart) + atMs;
  if (!Number.isFinite(timestamp)) return '—';
  return messageTimeFormatter.format(timestamp);
}

export function isOld(atMs: number | null, nowMs: number, stale = false) {
  return stale || atMs === null || !Number.isFinite(atMs) || !Number.isFinite(nowMs) || atMs > nowMs || nowMs - atMs > TELEMETRY_MAX_AGE_MS;
}

export function Tyre({ compound, age }: { compound: Compound; age?: number | null }) {
  return <span className="tyre-readout" title={`${compoundNames[compound]}${age == null ? '' : ` · 已使用 ${age} 圈`}`}>
    <span className={`tyre tyre-${compound.toLowerCase()}`}>{compoundCodes[compound]}</span>
    {age !== undefined && <span className="tyre-age">{age ?? '—'}</span>}
  </span>;
}
